import { useEffect, useState } from "react";
import {
  analyticsConfigured,
  preferenceKey,
  privacySignalActive,
  readAnalyticsEnabled,
  setAnalyticsEnabled,
} from "../analytics";
import "./AnalyticsPreferences.css";

export function AnalyticsPreferences() {
  const [enabled, setEnabled] = useState(readAnalyticsEnabled);
  const blocked = privacySignalActive();
  useEffect(() => {
    const sync = () => setEnabled(readAnalyticsEnabled());
    const storage = (event: StorageEvent) => {
      if (event.key === preferenceKey || event.key === null) sync();
    };
    window.addEventListener("storage", storage);
    window.addEventListener("etlyn-analytics-preference", sync);
    return () => {
      window.removeEventListener("storage", storage);
      window.removeEventListener("etlyn-analytics-preference", sync);
    };
  }, []);
  if (!analyticsConfigured) return null;
  return (
    <section
      className="analytics-policy-preference"
      aria-label="Analytics preferences"
    >
      <div>
        <h3>Product analytics</h3>
        <p>
          {blocked
            ? "Disabled by your browser’s privacy preference."
            : enabled
              ? "Cookieless analytics is enabled. You can opt out at any time."
              : "Analytics is disabled in this browser."}
        </p>
      </div>
      <button
        type="button"
        disabled={blocked}
        onClick={() => setAnalyticsEnabled(!enabled)}
      >
        {enabled ? "Disable analytics" : "Enable analytics"}
      </button>
    </section>
  );
}
